import { styled } from '../../../../theme';
import { Icon } from '../../../Icon';

export const NotificationIcon = styled(Icon).attrs((props) => ({
	...props,
	size: 'xl',
}))``;
